import { jsonMember, jsonObject } from 'typedjson';

@jsonObject
export class MultimediaDimensionsResponse {
  @jsonMember(Number)
  public readonly width!: number;

  @jsonMember(Number)
  public readonly height!: number;
}
